import request from '../request'
import requestUrl from '../requestUrl'
import requestParam from '../requestParam'
import { serviceWithHeader } from '../request'

//contract
//新增
export const addContractInfo = (params) => {
    return request({
        url: requestUrl('/admin/adminContract/save'),
        method: 'post',
        data: requestParam(params)
    })
}
//删除
export const deleteContractInfo = (params) => {
    return request({
        url: requestUrl('/admin/adminContract/deleteInfo'),
        method: 'post',
        data: requestParam(params)
    })
}
// 查询列表信息
export const queryContractInfo = (params) => {
    return request({
        url: requestUrl('/admin/adminContract/queryContractInfo'),
        method: 'post',
        data: requestParam(params)
    })
}
export const queryContractInfoEntityName = (params) => {
    return request({
        url: requestUrl('/admin/adminContract/queryContractInfoEntityName'),
        method: 'post',
        data: requestParam(params)
    })
}
//更新entity
export const updateContractEntityName = (params) => {
    return request({
        url: requestUrl('/admin/adminContract/updateEntityName'),
        method: 'post',
        data: requestParam(params)
    })
}
//批量更新entityName
export const batchUpdateContractInfo = (params) => {
    return request({
        url: requestUrl('/admin/adminContract/batchUpdateInfo'),
        method: 'post',
        data: requestParam(params)
    })
}
//导出
export const exportList = (params) => {
    return serviceWithHeader({
        url: requestUrl('/admin/adminContract/export'),
        method: 'post',
        data: requestParam(params),
        responseType: 'blob'
    })
}
//查询留言
export const queryAdminMessage = (params) => {
    return request({
        url: requestUrl(`/admin/adminMessage/queryAdminMessage`),
        method: 'post',
        data: requestParam(params)
    })
}

// 发送留言
export const sendSingleMessageBoard = (params) => {
    return request({
        url: requestUrl('/admin/adminMessage/save'),
        method: 'post',
        data: requestParam(params)
    })
}

// 删除留言
export const deleteSingleMessageBoard = (params) => {
    return request({
        url: requestUrl('/admin/adminMessage'),
        method: 'delete',
        data: params
    })
}

//删除附件
export const deleteUploadFiles = (params) => {
    return request({
        url: requestUrl(`/admin/adminContract/deleteUploadFiles?fileId=${params.fileId}`),
        method: 'post'
    })
}

//fee agreements
export const queryFeeAgreementInfo = (params) => {
    return request({
        url: requestUrl('/admin/adminFeeAgreement/queryFeeAgreementInfo'),
        method: 'post',
        data: requestParam(params)
    })
}
export const queryFeeAgreementInfoEntityName = (params) => {
    return request({
        url: requestUrl('/admin/adminFeeAgreement/queryFeeAgreementInfoEntityName'),
        method: 'post',
        data: requestParam(params)
    })
}
export const saveFeeAgreement = (params) => {
    return request({
        url: requestUrl('/admin/adminFeeAgreement/save'),
        method: 'post',
        data: requestParam(params)
    })
}
export const deleteFeeAgreement = (params) => {
    return request({
        url: requestUrl('/admin/adminFeeAgreement/deleteInfo'),
        method: 'post',
        data: requestParam(params)
    })
}
export const updateFeeAgreement = (params) => {
    return request({
        url: requestUrl('/admin/adminFeeAgreement/updateInfo'),
        method: 'post',
        data: requestParam(params)
    })
}
export const batchUpdateFeeAgreementInfo = (params) => {
    return request({
        url: requestUrl('/admin/adminFeeAgreement/batchUpdateInfo'),
        method: 'post',
        data: requestParam(params)
    })
}
//导出
export const exportFeeAgreementList = (params) => {
    return serviceWithHeader({
        url: requestUrl('/admin/adminFeeAgreement/export'),
        method: 'post',
        data: requestParam(params),
        responseType: 'blob'
    })
}
//vat
export const queryVatInfo = (params) => {
    return request({
        url: requestUrl('/admin/adminVatInformation/queryVatInformation'),
        method: 'post',
        data: requestParam(params)
    })
}
export const queryVatInformationEntityName = (params) => {
    return request({
        url: requestUrl('/admin/adminVatInformation/queryVatInformationEntityName'),
        method: 'post',
        data: requestParam(params)
    })
}

//导出
export const exportVatList = (params) => {
    return serviceWithHeader({
        url: requestUrl('/admin/adminVatInformation/export'),
        method: 'post',
        data: requestParam(params),
        responseType: 'blob'
    })
}
export const exportVatTpl = (params) => {
    return serviceWithHeader({
        url: requestUrl('/admin/adminVatInformation/downloadVatFormTemplate'),
        method: 'get',
        data: requestParam(params),
        responseType: 'blob'
    })
}
//invoices
export const queryTodayCount = (params) => {
    return request({
        url: requestUrl('/admin/adminMessage/queryTodayCount'),
        method: 'post',
        data: requestParam(params)
    })
}
export const queryInvoiceTodayCommentInfos = (params) => {
    return request({
        url: requestUrl('/admin/adminInvoice/queryTodayCommentInfos'),
        method: 'post',
        data: requestParam(params)
    })
}
export const queryVatTodayCommentInfos = (params) => {
    return request({
        url: requestUrl('/admin/adminVatInformation/queryTodayCommentInfos'),
        method: 'post',
        data: requestParam(params)
    })
}
export const queryInvoicesInfo = (params) => {
    return request({
        url: requestUrl('/admin/adminInvoice/queryInvoiceInfo'),
        method: 'post',
        data: requestParam(params)
    })
}
export const queryInvoiceEntityName = (params) => {
    return request({
        url: requestUrl('/admin/adminInvoice/queryInvoiceEntityName'),
        method: 'post',
        data: requestParam(params)
    })
}

//导出
export const exportInvoicesList = (params) => {
    return serviceWithHeader({
        url: requestUrl('/admin/adminInvoice/export'),
        method: 'post',
        data: requestParam(params),
        responseType: 'blob'
    })
}

export const previewInvoice = (params) => {
    return request({
        url: requestUrl('/admin/adminInvoice/getPdfPreview'),
        method: 'post',
        data: requestParam(params),
        responseType: 'blob'
    })
}

//查询关联发票
export const queryFapiaoInfo = (params) => {
    return request({
        url: requestUrl('/admin/adminFapiao/queryFapiaoInfo'),
        method: 'post',
        data: requestParam(params)
    })
}

//发票预览
export const getPdfPreview = (params) => {
    return request({
        url: requestUrl('/admin/adminFapiao/getPdfPreview'),
        method: 'post',
        data: requestParam(params),
        responseType: 'blob'
    })
}

//导出发票信息
export const exportFapiaoList = (params) => {
    return serviceWithHeader({
        url: requestUrl('/admin/adminFapiao/export'),
        method: 'post',
        data: requestParam(params),
        responseType: 'blob'
    })
}

